import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from './IssueNode.mjs';
import {
  ValidatedSetLens3tjmcbmmtgp0c as ValidatedSetLens,
  ValidatedModifyLensxnr6y4izl6zn as ValidatedModifyLens,
} from './validationLenses.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Draft3jz09icer2h2u as Draft } from '../../core/Draft.mjs';
import { MutableValidated2ognu5vxf17ur as MutableValidated } from './Validated.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function validated(_this__u8e3s4, reportTo) {
  reportTo = reportTo === VOID ? null : reportTo;
  return new (RootValidatedDraft())(_this__u8e3s4, reportTo);
}
function *_generator_set__cb7isu($this, value, $completion) {
  var tmp = $this.cav_1.gah(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var RootValidatedDraftClass;
function RootValidatedDraft() {
  if (RootValidatedDraftClass === VOID) {
    class $ {
      constructor(draft, reportTo) {
        reportTo = reportTo === VOID ? null : reportTo;
        this.cav_1 = draft;
        var tmp = this;
        var tmp1_elvis_lhs = reportTo == null ? null : reportTo.tat();
        tmp.dav_1 = tmp1_elvis_lhs == null ? new (IssueNode())() : tmp1_elvis_lhs;
      }
      vat() {
        return this.dav_1;
      }
      tak(get, set) {
        return ValidatedSetLens().dau(this, get, set);
      }
      bak(get, modify) {
        return ValidatedModifyLens().lau(this, get, modify);
      }
      yaj() {
        return this.cav_1.yaj();
      }
      zaj($completion) {
        return this.cav_1.zaj($completion);
      }
      lai() {
        this.cav_1.lai();
      }
      aak() {
        return this.cav_1.aak();
      }
      qah() {
        return this.cav_1.qah();
      }
      tah(listener) {
        return this.cav_1.tah(listener);
      }
      iaj() {
        return this.cav_1.iaj();
      }
      gah(value, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_set__cb7isu.bind(VOID, this, value), $completion);
      }
      cak(value) {
        this.cav_1.cak(value);
      }
    }
    initMetadataForClass($, 'RootValidatedDraft', VOID, VOID, [Draft(), MutableValidated()], [0, 1]);
    RootValidatedDraftClass = $;
  }
  return RootValidatedDraftClass;
}
//region block: exports
export {
  validated as validated2q9ie09qg9r46,
};
//endregion

//# sourceMappingURL=ValidatedDraft.mjs.map
